import { TextField, Toolbar, Typography } from '@mui/material';
import { getUserFullName } from 'app/utils/appHelpers';
import { useState } from 'react';

function UserCustomDataTableToolbar({ pageTitle, data2, setData, setHighlightQuery }) {

    const [searchText, setSearchText] = useState("");
    const handleChangeSearchText = (text) => {
        if (text !== "") {
            const search_filtered_data = text === '' ?
                data2 : data2.filter(item => getUserFullName(item).toLocaleLowerCase().includes(text.toLocaleLowerCase()))

            setSearchText(text);
            setHighlightQuery(text);
            setData(search_filtered_data);

        } else {
            setSearchText(text);
            setHighlightQuery(text);
            setData(data2);
        }
    };


    return (
        <Toolbar className="table-header row" sx={{ justifyContent: 'right', background: '#e1e1e1' }}>
            <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>   {pageTitle}
            </Typography>

            <div>

                <TextField

                    id="searchText1xe"
                    value={searchText}
                    onChange={(e) => handleChangeSearchText(e.target.value)}
                    margin="dense"
                    size="small"
                    label={"Arama Yap"}
                    className="mr-4"
                    // autoFocus
                    style={{ width: "200px", background: 'white', float: 'right' }}
                    placeholder={'Bilgi'}
                />
            </div>

        </Toolbar>
    );
};

export default UserCustomDataTableToolbar